import { render, staticRenderFns } from "./reward_gift_edit.vue?vue&type=template&id=24830e2d&scoped=true"
import script from "./reward_gift_edit.vue?vue&type=script&lang=js"
export * from "./reward_gift_edit.vue?vue&type=script&lang=js"
import style0 from "./reward_gift_edit.vue?vue&type=style&index=0&id=24830e2d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24830e2d",
  null
  
)

export default component.exports